<template>
  <BaseHybridLink v-bind="$attrs"
                  v-on="$listeners"
                  :disabled="disabled"
                  :href="href"
                  :isRouterLink="isRouterLink"
                  :openInCurrentTab="openInCurrentTab"
                  :to="to">
    <BaseImage v-bind="imageAttrs"
               :imageStyle="imageStyle"
               :src="src ? src : require('@img/user.svg')" />
  </BaseHybridLink>
</template>

<script>
  import BaseHybridLink from '@base/base-hybrid-link'
  import BaseImage from '@base/base-image'
  const path = require('path');

  export default {
    name: 'HybridLinkUserImagePrimary',
    inheritAttrs: false,
    components: {
      BaseImage,
      BaseHybridLink,
    },
    props: {
      disabled: { type: Boolean, required: false, default: false },
      height: { type: String, required: false, default: 'none' },
      isRouterLink: { type: Boolean, required: false, default: false },
      openInCurrentTab: { type: Boolean, required: false, default: false },
      src: { type: String, required: false, default: () => null },
      tenantUserId: { type: Number, required: false, default: () => null },
      width: { type: String, required: false, default: 'none' },
    },
    computed: {
      href: function () {
        return this.isRouterLink ? null : `${path.join(process.env.BASE_URL, 'users', this.tenantUserId.toString())}`;
      },
      imageAttrs: function () {
        return {
          borderRadius: '50%',
          borderWidth: '1px',
          cursor: this.tenantUserId == null || this.disabled ? 'default' : 'pointer',
          height: this.height,
          width: this.width,
        }
      },
      imageStyle: function () {
        return {
          objectFit: 'cover',
          filter: {
            '': 'none',
            hover: `opacity(${this.opacity})`,
            active: `opacity(${this.opacity})`,
          },
        };
      },
      opacity: function () {
        return this.tenantUserId == null || this.disabled ? 0.5 : 1.0;
      },
      to: function () {
        return this.isRouterLink ? { name: 'user', params: { id: this.tenantUserId } } : {};
      },
    },
  };
</script>
